// skills/pyre/index.js
// Pyre skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderPyreUI, updatePyreUI, initPyreUI, toggleBurning, toggleRitual, upgradeTool, switchTab } from './pyreUI.js';

/**
 * Pyre skill configuration
 */
const pyreConfig = {
    id: 'pyre',
    name: 'Pyre',
    icon: '🔥',
    iconImage: 'assets/icons/skill_icons/pyre.png',
    description: 'Burn logs for experience',

    tabs: [
        { id: 'logs', name: 'Logs', default: true },
        { id: 'rituals', name: 'Rituals' },
    ],

    render(params = {}) {
        renderPyreUI();
    },

    update() {
        updatePyreUI();
    },

    init() {
        initPyreUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('pyre', pyreConfig);

if (typeof window !== 'undefined') {
    window.pyreUI = {
        toggleBurning,
        toggleRitual,
        upgradeTool,
        switchTab
    };
}

export default pyreConfig;
